import { XCard, XPackBy, XTypography } from "~/jsx/components/design";
import { ModalNames } from "~/jsx/context/ModalNames";
import { useViewingPlayerOpt } from "~/jsx/hook";
import { Sizes, Spacing } from "~/jsx/theme";
import { XDesignModal } from "../design/XDesignModal";
import { RauriRandom } from "~/utils";
import { AgentEffectDescription } from "~/business";

export const XLookDeckModal = () => {
  const viewingPlayer = useViewingPlayerOpt();
  if (!viewingPlayer) return null;
  const {
    deck,
    playerLeader: { globalEffect },
  } = viewingPlayer;
  const nextDrawnCard = deck.last();
  const canLookAtNextCard =
    nextDrawnCard && AgentEffectDescription.is(globalEffect, "prescience");
  return (
    <XDesignModal
      name={ModalNames.lookDeck}
      title={<>Cards in your deck (random order)</>}
    >
      <XPackBy packSize={5} gap={Spacing.px8}>
        {RauriRandom.fromFixedSeed(deck.pile.map((card) => card.id).join("_"))
          .shuffle([...deck.pile])
          .map((card) => (
            <div key={card.id}>
              <XCard
                card={card}
                width={Sizes.cardWidths.normal}
                removeAnimationId={true}
              />
              {canLookAtNextCard && card.id === nextDrawnCard.id && (
                <XTypography style={{ textAlign: "center" }}>
                  Next drawn card
                </XTypography>
              )}
            </div>
          ))}
      </XPackBy>
    </XDesignModal>
  );
};
